import React from 'react';
import { Col, Row } from 'antd';
import {
  Cell,
  Legend,
  Pie,
  PieChart as RPieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

const CustomCameraTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: '#000',
          padding: '10px',
        }}
      >
        <span style={{ color: `${payload[0].payload.color}` }}>{`${payload[0].name
          }: ${((payload[0].value / payload[0].payload.total) * 100).toFixed(
            2,
          )}%`}</span>
      </div>
    );
  }

  return null;
};

const renderLegend = (props) => {
  const { payload } = props;
  return (
    <ul className="legend-wrapper">
      {payload.map((entry, index) => (
        <li
          className="item-legend"
          style={{ color: entry.color }}
          key={`item-${index}`}
        >
          <span className="bullet" style={{ background: entry.color }}></span>
          {`${entry.value} - ${(entry.payload?.percent * 100).toFixed(2)}%`}
        </li>
      ))}
    </ul>
  );
};

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  if (percent === 0) {
    return null;
  }

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize="smaller"
    >
      {`${(percent * 100).toFixed(2)}%`}
    </text>
  );
};

const UptimeReportSection = ({ data, cameraData, gatewayData }) => {
  if (
    !data?.cameraDisconnectionSession &&
    !data?.gatewayDisconnectionSession
  ) {
    return null;
  }

  return (
    <div>
      <div className="section-title">THỜI GIAN HOẠT ĐỘNG</div>
      <Row gutter={8}>
        <Col span={12}>
          <div className="chart-item content-center">
            <div className="chart-title">Camera</div>
            <Row style={{ width: '100%' }}>
              <Col span={6}>
                <div className="extra-info">
                  <div>Camera Quantity</div>
                  <div className="total-device">
                    {data?.cameraDisconnectionSession?.totalCamera || 0}
                  </div>
                </div>
              </Col>
              <Col span={18}>
                <ResponsiveContainer width={500} height={300}>
                  <RPieChart width={500} height={300}>
                    <Pie
                      dataKey="value"
                      isAnimationActive={false}
                      data={cameraData}
                      cx="50%"
                      cy="50%"
                      outerRadius={90}
                      innerRadius={40}
                      fill="#8884d8"
                      labelLine={false}
                      label={renderCustomizedLabel}
                    >
                      {cameraData?.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={cameraData[index].color}
                          stroke="none"
                        />
                      ))}
                    </Pie>

                    <Tooltip content={<CustomCameraTooltip />} />
                    <Legend
                      layout="vertical"
                      align="left"
                      verticalAlign="middle"
                      content={renderLegend}
                    />
                  </RPieChart>
                </ResponsiveContainer>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={12}>
          <div className="chart-item content-center">
            <div className="chart-title">Gateway</div>
            <Row style={{ width: '100%' }}>
              <Col span={6}>
                <div className="extra-info">
                  <div>Gateway Quantity</div>
                  <div className="total-device">
                    {data?.gatewayDisconnectionSession?.totalGateway || 0}
                  </div>
                </div>
              </Col>
              <Col span={18}>
                <ResponsiveContainer width={700} height={300}>
                  <RPieChart width={700} height={300}>
                    <Pie
                      dataKey="value"
                      isAnimationActive={false}
                      data={gatewayData}
                      cx="50%"
                      cy="50%"
                      outerRadius={90}
                      innerRadius={40}
                      fill="#8884d8"
                      labelLine={false}
                      label={renderCustomizedLabel}
                    >
                      {gatewayData?.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={gatewayData[index].color}
                          stroke="none"
                        />
                      ))}
                    </Pie>

                    <Tooltip content={<CustomCameraTooltip />} />
                    <Legend
                      align="center"
                      verticalAlign="middle"
                      content={renderLegend}
                    />
                  </RPieChart>
                </ResponsiveContainer>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UptimeReportSection;
